import { Random as RauriRandomRaw } from "rauricoste-random";

const isTest = process.env.NODE_ENV === "test";

export const Random = isTest
  ? RauriRandomRaw.fromFixedSeed("test")
  : RauriRandomRaw.fromFixedSeed("seed1");

export const RauriRandom = RauriRandomRaw;
